import name from 'forms/shared/validators/models/name/name';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { DEFAULT_LATEST } from 'constants/dateLimits';
import { setToStartOfMonth } from 'helpers/date';
import { RelationshipsCohabitantOtherNameModel } from '../types';

export const relationshipsCohabitantItemOtherNameItemValidator: ValidateJSModel<RelationshipsCohabitantOtherNameModel> = {
  OtherName: {
    presence: true,
    model: { validator: name },
  },
  MaidenName: { presence: true, hasValue: true },
  DatesUsed: (value, attributes, attributeName, options) => ({
    presence: true,
    daterange: {
      earliest: setToStartOfMonth(options.earliest),
      latest: DEFAULT_LATEST,
      tooEarly: 'error.cohabitant.min',
    },
  }),
  Has: {},
};
